module.exports = __webpack_public_path__ + "img/img-host.36cbe1dc.png";